// extracted by mini-css-extract-plugin
module.exports = {"root":"control-bar_root__2ZgDp","grid":"control-bar_grid__34NFN","backButton":"control-bar_backButton__1Pydu","colorPickerLabel":"control-bar_colorPickerLabel__3xSJM"};